export interface ISchool {
    ocorrenciaNo: number;
    codigo: any;
    nomeescola: any;
    habilitado: boolean;
    uF: string;
    cIdade: any;
}